<template>
  <el-card class="tabs-card">
    <el-form
      :inline="true"
      ref="formRef"
      :model="tableParams"
      class="demo-form-inline"
    >
      <el-form-item label="检索" prop="search">
        <el-input
          v-model="tableParams.search"
          placeholder="检索内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="告警点位" prop="deviceId">
        <h-button @click="allClick">{{
          currentEquipment.length > 0
            ? `已选择${currentEquipment.length}台设备`
            : "全部设备"
        }}</h-button>
      </el-form-item>
      <el-form-item label="告警时间">
        <el-date-picker
          v-model="time"
          type="datetimerange"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="告警源类型" prop="alarmSource">
        <el-select v-model="tableParams.alarmSource" placeholder="告警类型">
          <el-option
            v-for="(item, index) in alarmTypeList"
            :key="index"
            :label="item.typeName"
            :value="item.sourceType"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="告警类型" prop="alarmType">
        <el-select v-model="tableParams.alarmType" placeholder="告警类型">
          <el-option
            v-for="(item, index) in sourceTypeList"
            :key="index"
            :label="item.value"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="状态" prop="alarmStatus">
        <el-select v-model="tableParams.alarmStatus" placeholder="状态">
          <el-option
            v-for="(item, index) in alarmStatusList"
            :key="index"
            :label="item.value"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="告警等级" prop="alarmLevel">
        <el-select v-model="tableParams.alarmLevel" placeholder="告警等级">
          <el-option
            v-for="(item, index) in alarmLevelList"
            :key="index"
            :label="item.value"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <h-button type="primary" @click="refreshTable">查询</h-button>
        <h-button @click="resetForm(formRef)">重置</h-button>
        <h-button
          type="primary"
          :disabled="tableSelectList.length === 0"
          @click="handlebtn"
          >批量处理</h-button
        >
        <h-button type="primary">导出</h-button>
      </el-form-item>
    </el-form>
    <el-tabs class="tabs-box" v-model="activeName" tab-position="top">
      <el-tab-pane label="列表模式" name="one">
        <alarmTable
          ref="tableListRef"
          :tableParams="tableParams"
          :alarmTablestatus="alarmTablestatus"
          @tableSelect="handleTable"
        ></alarmTable>
      </el-tab-pane>
      <el-tab-pane label="地图模式" name="two">
        <alarmMap
          v-if="activeName == 'two'"
          :tableParams="tableParams"
        ></alarmMap>
      </el-tab-pane>
    </el-tabs>
    <transfer-application
      @transferApplicationList="getTransferList"
      v-model:visible="moveVisible"
      v-show="moveVisible"
    ></transfer-application>
    <alarmDetailDialog
      v-if="alarmDetailVisible"
      v-model:visible="alarmDetailVisible"
      :itemInfo="alarmDetailItem"
    ></alarmDetailDialog>
    <handleDialog v-model="formVisible"></handleDialog>
  </el-card>
</template>
<script>
import { defineComponent, reactive, toRefs, ref, watchEffect } from "vue";
import moment from "moment";
import util from "@util/js";

import alarmTable from "../../components/alarmTable.vue";
import alarmMap from "../../components/alarmMap.vue";
import { getDict } from "@/api/constant";
import { getTypeInfo } from "@/api/alarmCenter/alarmCenter.js";
export default defineComponent({
  name: "realtimeAlarm",
  components: { alarmTable, alarmMap },
  props: {},
  setup(props) {
    const state = reactive({
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      activeName: "one",
      tableParams: {
        search: "",
        alarmLevel: "", //告警等级，给接口请求用
        alarmStatus: "", //告警状态
        // alarmType: "", //告警类型
        alarmSource: "", //告警源类型
        startTime: "",
        endTime: "",
        type: "1", //告警页面类型 1:通用,2:人脸 3:车辆
        deviceId: [],
      },
      dataSource: [],
      userFormData: {},
      alarmTypeList: [],
      sourceTypeList: [],
      alarmLevelList: [],
      alarmStatusList: [],
      // ageList: [],
      alarmTablestatus: "1", //0:实时告警  1：通用告警
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      clickVisible: false,
      moveVisible: false,
      linkageVisible: false,
      currentPage: "",
      time: [new Date(), new Date()],
      currentEquipment: [],
      tableSelectList: [],
    });
    const refData = toRefs(state);
    const tableListRef = ref();
    const formRef = ref(null);
    const start = new Date();
    state.time[0] = start.setTime(start.getTime() - 3600 * 1000 * 24);
    watchEffect(() => {
      //设置时间
      state.tableParams.startTime = moment(state.time[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      state.tableParams.endTime = moment(state.time[1]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    });
    // 点击查询按钮
    const refreshTable = () => {
      tableListRef.value && tableListRef.value.refreshTable();
    };
    // 重置表单
    const resetForm = (formEl) => {
      state.tableParams.deviceId = [];
      state.currentEquipment = [];
      state.alarmLevel = "";
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableListRef.value && tableListRef.value.refresh();
    };
    // 处理
    const handlebtn = () => {
      tableListRef.value && tableListRef.value.handlebtn();
    };
    // 处理
    const handleTable = (value) => {
      state.tableSelectList = value;
    };
    //打开告警详情弹窗
    const clickAlarmDetial = (item) => {
      state.alarmDetailVisible = true;
      state.alarmDetailItem = item;
      console.log(item);
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      console.log(operate);
      if (emitKey === "handle") {
        state.formVisible = true;
      }
    };

    // 获取数据字典
    const queryMenuType = async () => {
      const alarmType = await getTypeInfo(); //告警源类型
      // const sourceType = await getSourceType(); //告警类型
      const alarmLevel = await getDict("zghz-level-type"); //告警等级
      const alarmStatus = await getDict("zghz-level-status"); //告警状态

      state.alarmTypeList = [
        { typeName: "不限", sourceType: "" },
        ...alarmType.list,
      ];
      // // state.sourceTypeList = [{ value: "不限", code: "" }, ...sourceType.dict];
      state.alarmLevelList = [{ value: "不限", code: "" }, ...alarmLevel.dict];
      state.alarmStatusList = [
        { value: "不限", code: "" },
        ...alarmStatus.dict,
      ];
    };
    queryMenuType();
    const clickTable = async (item) => {
      console.log(item);
      state.formStatus = 4;
      state.clickVisible = true;
      const res = await infoQuery(item.prisonId);
      state.userFormData = _.cloneDeep(res.prisonInfo);
    };
    //获取穿梭框数据
    const getTransferList = (val) => {
      state.moveVisible = false;
      val.forEach((element) => {
        state.tableParams.deviceId.push(element.deviceId);
      });
      state.currentEquipment = val;
      console.log(state.currentEquipment);
    };
    const allClick = () => {
      state.moveVisible = true;
    };
    return {
      ...refData,
      formRef,
      tableListRef,
      moment,
      allClick,
      refreshTable,
      resetForm,
      handleClick,
      userSubmit,
      clickTable,
      getTransferList,
      clickAlarmDetial,
      handlebtn,
      handleTable,
    };
  },
});
</script>
<style lang="scss" scoped>
.tabs-card {
  display: flex;
  flex-direction: column;
  .tabs-box {
    flex: 1;
  }
}
</style>
